import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { MENU_BUTTON_STYLE, offcanvasColors } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { MenuButton } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";

@Component({
  selector: "app-button-page-single-image-style-component",
  templateUrl: "./button-page-single-image-style-component.component.html",
  styleUrls: ["./button-page-single-image-style-component.component.scss"],
})
export class ButtonPageSingleImageStyleComponentComponent implements OnInit, OnDestroy {
  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService
  ) {}
  styles = MENU_BUTTON_STYLE;

  singleImageTypes = [{
    key: this.styles.STYLE_1000,
    name: 'GENERALS.STANDARD',
    image:'https://nandbox.com/wp-content/uploads/2024/02/large-img.webp'
  },
  {
    key: this.styles.STYLE_2000,
    name: 'GENERALS.NUMERIC',
    image:'https://nandbox.com/wp-content/uploads/2024/02/top-text-and-img.webp'
  },
  {
    key: this.styles.STYLE_3000,
    name: 'GENERALS.PHONE',
    image:'https://nandbox.com/wp-content/uploads/2024/02/top-text-and-img.webp'
  },{
    key: this.styles.STYLE_4000,
    name: 'GENERALS.EMAIL',
    image:'https://nandbox.com/wp-content/uploads/2024/02/right-side-text-card.webp'
  },{
    key: this.styles.STYLE_5000,
    name: 'GENERALS.EMAIL',
    image:'https://nandbox.com/wp-content/uploads/2024/02/left-side-card.webp'
  }]

  @Input() button_id: string;
  button: MenuButton;
  mode: string;

  // default values
  offCanvasSubscription: any;

  offcanvasColors = offcanvasColors;
  newTab = false;
  button_bgcolor: string;
  row_id: string;
  button_style ;
  data: any;
  currentMenuSubscription: any;
  sortedButtonList: any[];
  buttonList: any;
  off_canvas_key : string = "button"
  ngOnInit() {
    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.button&&
          data.button.button_id == this.button_id
        ) {

          this.data = data.data;
          this.sortedButtonList = data.data["sortedButtonList"];
          this.buttonList = this.data["buttonList"];

          this.button = { ...data.button };
          this.mode = localStorage.getItem("mode");

          if (this.button.button_style) {
            this.button_style = this.button.button_style;
          }

        }
      }
    );

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (data && data["buttonList"][this.button_id] && !data.fromButton) {
          this.data = data;
          this.sortedButtonList = this.data["sortedButtonList"];
          this.buttonList = this.data["buttonList"];
          this.button = data["buttonList"][this.button_id];
        }
      }
    );
  }

  styleChange(event) {
    this.button_style = event;
    this.button.button_style = event;
    this.mdw.changeTab({ button: this.button, tab:{module: "page" }}, this.mode, true);
     /// update the button in the data
     this.buttonList[this.button_id] = this.button;
     let index = this.sortedButtonList[this.button.row_id].findIndex(
       (e) => e.button_id == this.button_id
     );
     this.sortedButtonList[this.button.row_id][index] = { ...this.button };
     this.data["sortedButtonList"] = this.sortedButtonList;
     this.data["buttonList"] = this.buttonList;
     this.data["off_canvas_key"] = this.off_canvas_key;
     this.data["currentButton"] = this.button;

     this.mdw._currentMenuContainer.next(this.data);

     ////////////////////////////***********************/????????????//////////
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
  }
}
